import i18nextRessources from 'translation/i18nextRessources'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: i18nextRessources,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
